<!--
 * @Author: wsx
 * @Date: 2022-03-05 14:26:02
 * @LastEditTime: 2022-03-05 18:32:47
 * @Description:安防设施
 * @FilePath: \smart-community\src\views\smartApplication\threeSolidQuery\components\security.vue
-->
<template>
  <div class="security">
    <div class="search-results-box">
      <ul class="search-results">
        <template v-for="(item, index) in securitylist" :key="index">
          <li class="results-item">
            <div class="item-img">
              <img v-if="item.imageUrl" :src="url + item.imageUrl" alt="" />
              <img v-else src="~@/assets/images/moren.png" alt="" />
            </div>
            <div class="item-details">
              <!-- <div class="details-info">
                <span>惠民园6幢5单元人脸抓拍</span>
              </div> -->
              <div class="details-info">
                <span class="label">设施类别</span>
                <span class="value">{{ item.securityTypeDict }}</span>
              </div>
              <div class="details-info">
                <span class="label">设施型号</span>
                <span class="value"></span>
              </div>
              <div class="details-info">
                <span class="label">安装地址</span>
                <span class="value">{{ item.securityAddress }}</span>
              </div>
              <div class="details-info">
                <span class="label">所属小区</span>
                <span class="value">惠民园</span>
              </div>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";
import { securitylist } from "@/api/threeSolid/threeSolid.js";
export default defineComponent({
  name: "security",
  setup(props) {
    const data = reactive({
      securitylist: [],
      url: window.imgURL,
    });
    const refData = toRefs(data);
    // 请求数据
    const queryData = (params) => {
      console.log("security-请求数据-参数", params);
      return getsecuritylist(params);
    };
    // 获取安防设备
    const getsecuritylist = async (search) => {
      const params = {
        page: 1,
        limit: 10000,
      };
      if (search) {
        params.search = search;
      }
      const res = await securitylist(params);
      data.securitylist = res.page.list;
      return res.page.list.length;
    };
    getsecuritylist();
    return { ...refData, queryData, getsecuritylist };
  },
});
</script>
<style lang="scss" scoped>
.security {
  .search-results-box {
    width: 100%;
    flex: 1;
    height: 100%;
    overflow: auto;
  }
  .search-results {
    width: 100%;
    flex: 1;
    overflow: auto;
    .results-item {
      padding: 10px 0;
      width: 100%;
      border-bottom: 1px solid #aab2c5;
      @include flex-row-s-c;
      .item-img {
        width: 100px;
        img {
          width: 100%;
        }
      }
      .item-details {
        flex: 1;
        margin-left: 10px;
        line-height: 28px;
        .details-info {
          font-size: 14px;
          @include flex-row-sb-c;
          & > span {
            display: inline-block;
          }
          .label {
            width: 90px;
          }
          .value {
            flex: 1;
          }
        }
      }
    }
  }
}
</style>
